module.exports = __webpack_public_path__ + "static/img/jinian@2x.bbe0ae11.png";